<template>
    <div class="recipe">
        <div class="top-nav">
            <v-btn text @click="$router.go(-1)">
                <v-icon>arrow_back</v-icon> Back
            </v-btn>
            <v-btn fab dark small depressed text color="black" @click="print">
                <v-icon dark>print</v-icon>
            </v-btn>
        </div>
        <div class="recipe-not-found" v-if="recipe === 'not found'">Recipe Not Found</div>
        <recipe-display :inline="false"></recipe-display>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    import RecipeDisplay from '../plugins/bft-nutrition-plugin/components/Recipe'

    export default {
        components: {RecipeDisplay},
        mounted() {
            //this.$store.commit('nutrition/SET_RECIPE', null)
            this.$store.dispatch('nutrition/loadRecipeSlug', {slug: this.$route.params.slug, global_region_id: this.$route.params.global_region_id})
        },
        methods: {
            pointItems (items) {
                if (!items) return []
                return items.split('\n')
            },
            print () {
                window.print()
            }
        },
        name: "Recipe",
        computed: {
            ...mapState({
                imageUrl: state => state.settings.imageUrl,
                recipe: state => state.nutrition.recipe
            })
        }
    }
</script>

<style scoped lang="scss">

    @import '../scss/variables';

    .recipe {
        &-container, &-not-found {
            margin: 20px 30px;
        }
        &-title {
            font-size: 22px;
            font-weight: bold;
            color: $primary;
            line-height: 28px;
        }
        &-serves {
            font-size: 18px;
            font-weight: normal;
            color: grey;
        }
        &-nutritional {
            font-size: 12px;
            color: grey;
        }
        &-ingredients, &-methods {
            color: #787874;
            font-size: 12px;
        }
        &-ingredients-title, &-methods-title {
            margin-top: 20px;
            font-weight: bold;
            font-size: 14px;
        }
        &-ingredients-items, &-methods-items {
            ul, ol {
                padding-left: 16px;
            }
        }
        &-methods-items {
            li {
                line-height: 16px;
                margin: 7px 0;
            }
        }
        &-notes {
            margin-top: 20px;
            font-size: 12px;
            font-style: italic;
        }
        .image-disclaimer {
            color: #000000;
            text-align: right;
            margin-bottom: 20px;
            padding-right: 10px;
            display: block;
            font-size: 12px;
        }
    }
</style>
